export const LOCAL_STORAGE_KEY = {
  userSession: 'user_session',
  menu: 'menu',
  role: 'role',
  previousURL: 'previous_url',
  params: 'query_parameters',
  organizationByPASS: 'organization_by_PASS',
  moduleIdAtPermDefaultDetail: "moduleId_at_perm_default_detail",
  permDefaultDetailId: "permDefaultDetailId"
};
